import {
  type ComponentProps,
  type ElementType,
  type ForwardedRef,
  forwardRef,
  type PropsWithChildren,
} from "react";
import { cn } from "ui";

export interface WorkoutItemWrapperProps<T extends ElementType>
  extends PropsWithChildren, ComponentProps<ElementType> {
  as?: T;
}

export const WorkoutItemWrapper = forwardRef(function WorkoutItemWrapper<
  T extends ElementType,
>(props: WorkoutItemWrapperProps<T>, ref: ForwardedRef<HTMLDivElement>) {
  const { as: Component = "div", children, className, ...rest } = props;

  return (
    <Component
      {...rest}
      className={cn(
        "shadow-[0px_0px_0px_1px_rgba(0,0,0,1)] shadow-border rounded-sm",
        className,
      )}
      ref={ref}
    >
      {children}
    </Component>
  );
});
